// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { html } from "lit";
import { str } from "@lit/localize";
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    h0fca6d6cbb0506c0: html `Intelligence di mercato`,
    h229e7d06093c2f3f: html `ESG e diversità`,
    h4b6568de605796be: html `CdA e governance`,
    h4e84df3b11ed9b4f: html `Guida e supporto`,
    h722c4148bfbe6706: html `Formazione e certificazioni`,
    h85f4df4fdcb8beed: html `Rischio e strategia`,
    hb6b70f369f25a7ac: html `Conformità ed etica`,
    hc639dc8eaab7815d: html `Issue e rapporti`,
    hcd22a6d6c40d8786: html `Audit e analisi`,
    "link-home": `Home`,
    "nav-section-home": `Home`,
    s032cd9f1245d3645: `Spazio`,
    s08e6d298452e8f68: `Audit`,
    s0910fa68dccfcaa6: `Data Market Intelligence`,
    s0a860146c6f28d97: `Apri la finestra di dialogo sui tasti di scelta rapida`,
    s0bae1af85a28bd4c: `Diligent Institute`,
    s0ccb779911d414a3: `Inventario delle risorse`,
    s14ba513bc8896c24: `Robot`,
    s1534ff9f453525e1: `Selezionare la prima cella`,
    s175d37c8eb04d73e: `Download`,
    s1967ea0b8a2b6015: `Esegui la cella selezionata`,
    s199f5853f4e718f7: `Progetti`,
    s24761a0cc8d9c0aa: `Organizzazione`,
    s299dc244af6aadff: `Customer Admin Boards`,
    s2aa747e75ad1b409: `Third-Party Manager`,
    s2b63dc08d32ccb09: `Scorri verso l'alto`,
    s2c2b04f2561a1d4b: `Analytics`,
    s2cfcd4e06c146db9: `Apri la finestra di dialogo sui selettori dell'organizzazione`,
    s2e109263b73c12d5: `Licenze`,
    s34d94212c9758944: `Strategia`,
    s353873ecbaa3efe9: `Freccia sinistra`,
    s3736464cf8d6fa08: `Team di supporto`,
    s392dc2954562a82b: `Editor di testo`,
    s39cccc90e6fe1d7f: `Gestore delle issue`,
    s3ab6763097d7412f: `Equity Invest`,
    s3d5b54e4d176209c: `Ultima diapositiva`,
    s3f809b62bcc2a44c: `Controllo della missione`,
    s45efff328e4d0a4d: `Cerca organizzazioni`,
    s460bf77c46d93bb4: `Chiudi la finestra di dialogo sui tasti di scelta rapida`,
    s469437ae00d48e37: `Espandi la riga attuale`,
    s47de2481b149190a: `Entities`,
    s4802e47fe2e95134: `Opzione`,
    s480d27b7a8b69ce5: `Scorri a sinistra`,
    s49ca4bf0e63593da: `Chiudi dialoghi`,
    s4b10acae683d2978: `Schermo intero`,
    s4b81aa9512692c4d: `Comprimi navigazione laterale`,
    s523eb9043213ff0d: `Corsivo`,
    s56410a6c80d5215c: `Sposta la cella in basso`,
    s58622fa7922ed03b: `Pulsante del menu di aiuto`,
    s586d6bd2eca2da93: `Utenti`,
    s5a41c3a63f1c18af: `Impostazioni del profilo`,
    s5b56a21c08c842c4: `Prima diapositiva`,
    s5c1ecf88259b79f9: `Presentazione`,
    s5cad0782f12d34b2: `Equity`,
    s5d9182f471cf98d1: `Mappe di conformità`,
    s5d929ff1619ac0c9: `Cerca`,
    s5db46d120dcba694: `Valutazioni`,
    s5e27738a2e8eb763: `Accedi`,
    s5e8250fb85d64c23: `Chiudi`,
    s5febcd9b311c16fe: `Scorri a destra`,
    s60565faf8db3a5cb: `Esegui questa cella e tutte le celle sopra`,
    s62bc518b503d1c76: `Selezionare la cella sotto`,
    s63b6edf663b6a3c5: `Aggiungi cella sotto`,
    s6d5cb7af3fa87c78: `Tracciatore di attività`,
    s6db55a42bcb74cfc: `Tracciatore di issue`,
    s6fb3409caa74b0a4: `Ctrl`,
    s70113bbc33303a81: `Menu di aiuto`,
    s7417792bbe720149: `Ripeti`,
    s74cb3d66f6a668e1: `Documentazione`,
    s7695095bb106d505: `Accuvio`,
    s7a4f059aaa029719: `Connect`,
    s7cfe12cd14df9950: `Esci`,
    s7db511600050e797: `Esegui questa cella e tutte le celle sotto`,
    s7deaf226ff8b192c: `Installer`,
    s7e388025be643d0d: `Invio`,
    s7eb1e34fc5ece4cd: `Menu del profilo`,
    s884bcdca26998a48: `Rapporti`,
    s89365ba6fa5cdb97: `Interrompi esecuzione`,
    s89ba33f94f92f3cc: `Campagne di identificazione`,
    s8f4be9f086eb530f: `Annulla`,
    s9021935bcdd703b9: `Apri un pannello laterale`,
    s9373ade6d85b4388: `Comprimi la riga attuale`,
    s947f21967d65c480: `Marketplace`,
    s9ab2385df7adbce0: `Evidenzia una riga`,
    s9dd12575273ac110: `Scorri verso il basso`,
    s9df9510d60035af3: `Apri menu del profilo`,
    s9f26843287bb592d: `Gruppi`,
    s9fda4232f5e1876a: `Ottieni aiuto`,
    sa05b93d8764f88ed: `Gestore del rischio`,
    sa103c8e0c776e11c: `Richiedi tasti di scelta rapida`,
    sa153c163bc11460d: `Centro attività`,
    sa35ed9234d3d66ce: `Nessuna organizzazione trovata`,
    sa4bb7742cdfc214e: `Director Boards`,
    sa872b0bfe51f2d40: `Struttura organizzativa`,
    saed6432f1517ea10: `Gestore delle risorse`,
    saf7a5eef69e5bb59: `Freccia su`,
    sb061ff5a347a296e: `Profilo`,
    sb206d700d26b14ff: `Sottolineato`,
    sb21cca7db5de38f3: `Storyboard`,
    sb284cd019b430d1e: `Nessun tasto di scelta rapida specifico dell'applicazione disponibile.`,
    sb32c8490570a8831: `Panoramica delle diapositive`,
    sb4484b8d878dffff: `Log di attività`,
    sb752d83c4e4619bc: str `Passa a ${0}`,
    sb888017adf7992b9: `Accademia di Diligent`,
    sbd63362a31200ab4: `Vai a Launchpad`,
    sbda32dab0c54ffdd: `Diapositiva successiva`,
    sbf84c104b8212e06: `Selezionare la cella sopra`,
    sc203eef710f83583: `Non supportiamo tasti di scelta rapida specifici per questa applicazione.`,
    sc2873891e8c3be68: `Editor di script di Robot`,
    sc835e30bc3bdd2fd: `Sposta la cella in alto`,
    sc8aa5792985e2ba3: `Impostazioni della piattaforma`,
    sca1a826088564455: `Risultati`,
    sca442b5dc0fd394c: `Freccia giù`,
    scdd4399eeeacd8f4: `Cambia organizzazione`,
    sd0864ea6cb6ef22e: `Community`,
    sd0b6082239185272: `Seleziona tutto`,
    sd1182e4e6a0ada64: `Policy Manager`,
    sd1b2ae9109b29cf0: `Navigazione laterale`,
    sd1c09a62f063a73b: `Gestore delle attività`,
    sd514ab1c93237dae: `Piani di assurance`,
    sd76505ffae553332: `Portale di ricerca`,
    sd81eecf773db25fc: `Esegui tutte le celle in sequenza`,
    sd8f923198e0c5c6a: `Fine`,
    sd90a1e198e1ac71e: `Esc`,
    sd9fb2375a5c991c5: `Non supportiamo tasti di scelta rapida specifici per questa applicazione, ma segnalaci eventuali suggerimenti.`,
    sdc599e1d5c823e75: `Selezionare l'ultima cella`,
    sdcc5f064d591aefd: `Diapositiva precedente`,
    se2faf168207b0a48: `Framework`,
    se3b4c857f91f80d7: `Tasti di scelta rapida`,
    se65e4e6f3696e997: `Formazione`,
    se93a3eaf86201ae7: `Maiusc`,
    sed2d45e3f811c81d: `Basico`,
    see0ef54044d25a50: `Book Admin Boards`,
    sf0d3b85da03d1e55: `Elimina la cella selezionata`,
    sf2d615b20d62225a: `Sondaggio di pianificazione`,
    sf41a0c89409353dc: `Freccia destra`,
    sf5597bb9f2103d2a: `Attivazioni`,
    sf7c0eba7c822e3d6: `Grassetto`,
    sf95b10c03a2d5872: `Apri navigazione laterale`,
    sf993c3199fefcb9c: `Alt`,
    sf9b1c0661a02d9f9: `Configurazione`,
    sfc6b9ce43d2c798c: `Schede orarie`,
    sfe3d666017079dce: `BoardEffect`,
    "shortcuts-home": `Home`,
};
